module.exports = __webpack_public_path__ + "2230c677bc07257ef21dd5e74f6f2edc.MP3";